import React, { useEffect } from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import OrderStatusInputs from '../../components/OrderStatusInputs/OrderStatusInputs';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import {
  updateOrderStatusRequestAction,
} from '../../store/orderStatus/orderStatusActions';

const UpdateOrderStatus = (props) => {
  const {
    updateOrderStatusRequest,
    isLoading,
    updateOrderStatusData,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();

  const orderStatusData = location.state?.orderStatus || null;

  useEffect(() => {
    if (!orderStatusData && id) {
      console.warn('No order status data found in route state. You may need to fetch by ID:', id);
    }
  }, [orderStatusData, id]);

  const handleOrderSubmit = (orderStatusData) => {
    console.log('Submitting updated order:', orderStatusData);
    updateOrderStatusRequest({
      data: orderStatusData,
      navigate: navigate
    });
  };

  const handleBackToOrders = () => {
    navigate('/order-status');
  };

  return (
    <div>
      <CContainer>
        <CBreadcrumb className="mb-4">
          <CBreadcrumbItem 
            href="#/order-status" 
            onClick={(e) => {
              e.preventDefault();
              handleBackToOrders();
            }}
          >
            {t('orders')}
          </CBreadcrumbItem>
          <CBreadcrumbItem active>{t('updateOrder')}</CBreadcrumbItem>
        </CBreadcrumb>

        <CRow>
          <CCol xs={12}>
            <CCard>
              <CCardHeader>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">{t('updateOrderStatus')}</h4>
                  {orderStatusData?.OrderStatusId && (
                    <small className="text-muted">
                      ID: {orderStatusData.OrderStatusId}
                    </small>
                  )}
                </div>
              </CCardHeader>
              <CCardBody>
                {orderStatusData ? (
                  <OrderStatusInputs 
                    onSubmit={handleOrderSubmit}
                    onCancel={handleBackToOrders}
                    isLoading={isLoading}
                    submitResponse={updateOrderStatusData}
                    initialData={orderStatusData}
                    isEdit={true}
                  />
                ) : (
                  <div className="text-center py-4">
                    <div className="text-muted">
                      {t('noDataFound')}
                    </div>
                    <button 
                      className="btn btn-primary mt-3"
                      onClick={handleBackToOrders}
                    >
                      {t('backToOrders')}
                    </button>
                  </div>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.loadingReducer?.isLoading || false,
    updateOrderStatusData: state.orderStatusReducer?.updateOrderStatusData || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrderStatusRequest: (payload) => {
      dispatch(updateOrderStatusRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateOrderStatus);